import { render, staticRenderFns } from "./HolidayCreate.vue?vue&type=template&id=06b6b704"
import script from "../../controllers/holiday/holiday-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/holiday/holiday-create.js?vue&type=script&lang=js&external"
import style0 from "./HolidayCreate.vue?vue&type=style&index=0&id=06b6b704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports